import { Box, Divider } from "@material-ui/core";
import {
    BroadcastMessage,
    Championship,
    Collections,
    Round,
    useCollection,
} from "api";
import copy from "copy-to-clipboard";
import cloneDeep from "lodash/cloneDeep";
import { DateTime } from "luxon";
import MaterialTable from "material-table";
import { useSnackbar } from "notistack";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useFirestore, useFirestoreConnect } from "react-redux-firebase";
import { useParams } from "react-router";
import { RootState } from "redux/model";
import { LOGIN_ERROR_MESSAGES } from "redux/reducers/authReducer";
import { BoxCard, Subtitle, Title } from "ui/componentes";
import useSound from "use-sound";
import { LocalizationPTBr } from "util/MaterialTableUtil";
const messageSound = require("../../../assets/sounds/broadcastMessage.mp3");

const BroadcastMessages = () => {
    const { roundId } = useParams<{ roundId }>();
    const [numberOfMessages, setNumberOfMessages] = useState(6);
    const firestore = useFirestore();
    const { enqueueSnackbar } = useSnackbar();
    const [play] = useSound(messageSound);

    useFirestoreConnect({
        collection: Collections.ROUNDS,
        doc: roundId,
        subcollections: [
            {
                collection: Collections.BROADCAST_MESSAGES,
                where: ["transmitted", "==", false],
            },
        ],
        storeAs: Collections.BROADCAST_MESSAGES,
    });

    const round =
        useCollection<Round>({
            collection: Collections.ROUNDS,
            doc: roundId,
        }) || {};
    const broadcastMessages = cloneDeep<BroadcastMessage[]>(
        useSelector((state: RootState) => {
            return state.firestore.ordered[Collections.BROADCAST_MESSAGES];
        }) || []
    );
    broadcastMessages.sort((m1, m2) => (m1.createdAt < m2.createdAt ? -1 : 1));
    const championship =
        useCollection<Championship>({
            collection: Collections.CHAMPIONSHIPS,
            doc: round ? round.championshipId : "-1",
        }) || {};
    const roundDate = useMemo(
        () =>
            round ? DateTime.fromISO(round.date).toFormat("dd/MM/yyyy") : "",
        [round]
    );

    useEffect(() => {
        if (broadcastMessages.length > numberOfMessages) {
            play();
        }
        setNumberOfMessages(broadcastMessages.length);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [broadcastMessages, play]);

    return (
        <Box display="flex" flexDirection="column" height="100%">
            <Box display="flex" justifyContent="space-around">
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-around"
                    minWidth={210}
                    padding={2}
                >
                    <Subtitle text="Campeonato" color="textSecondary" />
                    <Divider />
                    <Title text={championship?.name} color="textSecondary" />
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    minWidth={210}
                    padding={2}
                >
                    <Subtitle text={`Etapa`} color="textSecondary" />
                    <Divider />
                    <Title text={round.trackName} color="textSecondary" />
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    minWidth={210}
                    padding={2}
                >
                    <Subtitle text="Data" color="textSecondary" />
                    <Divider />
                    <Title text={roundDate} color="textSecondary" />
                </Box>
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                width="100%"
                height="100%"
            >
                <Box
                    id="editContent"
                    display="flex"
                    flexDirection="column"
                    alignContent="center"
                    width="90%"
                >
                    <MaterialTable
                        components={{ Container: BoxCard }}
                        title="Mensagens"
                        data={broadcastMessages}
                        columns={[
                            {
                                field: "message",
                                title: "Mensagem",
                            },
                        ]}
                        actions={[
                            (broadcastMessage) => ({
                                icon: "assignment",
                                tooltip: "Copiar mensagem",
                                disabled: broadcastMessage.transmitted,
                                onClick: () => {
                                    copy(broadcastMessage.message);
                                    enqueueSnackbar(
                                        `Mensagem copiada para o clipboard`,
                                        {
                                            variant: "info",
                                        }
                                    );
                                },
                            }),
                            (broadcastMessage) => ({
                                icon: "check",
                                tooltip: "Marcar como transmitida",
                                disabled: broadcastMessage.transmitted,
                                onClick: () => {
                                    firestore
                                        .collection(Collections.ROUNDS)
                                        .doc(roundId)
                                        .collection(
                                            Collections.BROADCAST_MESSAGES
                                        )
                                        .doc(broadcastMessage.id)
                                        .update({ transmitted: true })
                                        .then(() => {
                                            enqueueSnackbar(
                                                `Mensagem transmitida`,
                                                {
                                                    variant: "success",
                                                }
                                            );
                                        })
                                        .catch((error) => {
                                            console.error(error);
                                            enqueueSnackbar(
                                                LOGIN_ERROR_MESSAGES[
                                                    "permission-denied"
                                                ],
                                                {
                                                    variant: "error",
                                                }
                                            );
                                        });
                                },
                            }),
                        ]}
                        options={{
                            paging: false,
                            search: false,
                        }}
                        localization={LocalizationPTBr}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export { BroadcastMessages };
